/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListForumThreads200ResponseDataInner
 */
export interface ListForumThreads200ResponseDataInner {
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseDataInner
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseDataInner
     */
    forumCategoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseDataInner
     */
    carId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseDataInner
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseDataInner
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseDataInner
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseDataInner
     */
    body?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListForumThreads200ResponseDataInner
     */
    isPinned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListForumThreads200ResponseDataInner
     */
    isLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseDataInner
     */
    lastPostAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseDataInner
     */
    postCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseDataInner
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseDataInner
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ListForumThreads200ResponseDataInner interface.
 */
export function instanceOfListForumThreads200ResponseDataInner(value: object): value is ListForumThreads200ResponseDataInner {
    return true;
}

export function ListForumThreads200ResponseDataInnerFromJSON(json: any): ListForumThreads200ResponseDataInner {
    return ListForumThreads200ResponseDataInnerFromJSONTyped(json, false);
}

export function ListForumThreads200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListForumThreads200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'forumCategoryId': json['forum_category_id'] == null ? undefined : json['forum_category_id'],
        'carId': json['car_id'] == null ? undefined : json['car_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'title': json['title'] == null ? undefined : json['title'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'body': json['body'] == null ? undefined : json['body'],
        'isPinned': json['is_pinned'] == null ? undefined : json['is_pinned'],
        'isLocked': json['is_locked'] == null ? undefined : json['is_locked'],
        'lastPostAt': json['last_post_at'] == null ? undefined : json['last_post_at'],
        'postCount': json['post_count'] == null ? undefined : json['post_count'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ListForumThreads200ResponseDataInnerToJSON(json: any): ListForumThreads200ResponseDataInner {
    return ListForumThreads200ResponseDataInnerToJSONTyped(json, false);
}

export function ListForumThreads200ResponseDataInnerToJSONTyped(value?: ListForumThreads200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'forum_category_id': value['forumCategoryId'],
        'car_id': value['carId'],
        'user_id': value['userId'],
        'title': value['title'],
        'slug': value['slug'],
        'body': value['body'],
        'is_pinned': value['isPinned'],
        'is_locked': value['isLocked'],
        'last_post_at': value['lastPostAt'],
        'post_count': value['postCount'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

